import { api } from 'api';
import { call, put } from 'redux-saga/effects';
import { suggestionActions } from 'store/data/suggestion';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Deletes a suggestion via Suggestion_Delete and removes it from the
// suggestion domain. The store dispatch only fires on API success —
// operationWrapper catches errors and short-circuits before the put.
export function* deleteSuggestion(args: { suggestionId: string }) {
  const { suggestionId } = args;

  function* work(tenantId: string) {
    yield call(api.deleteSuggestion, { tenantId, suggestionId });

    yield put(suggestionActions.remove(suggestionId));
  }

  yield call(operationWrapper, work, JwtFeature.Improvements);
}
